export { default } from './Tray'



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Tray/index.js